( function ( $ ) {
	function initializeTeam( $block ) {
		$block.find('.indy-block-team .illustration-wrapper').each(function () {
			const colors = ['primary', 'secondary', 'tertiary']
			const randomNumber = Math.floor(Math.random() * colors.length);
			$(this).addClass('indy-fill-' + colors[randomNumber])
		})
	}
	$(document).ready(function (e) {
		$('.indy-block-team .illustration-wrapper').each(function () {
			const colors = ['primary', 'secondary', 'tertiary']
			const randomNumber = Math.floor(Math.random() * colors.length);
			$(this).addClass('indy-fill-' + colors[randomNumber])
		})
	})


	if( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=indy/team', initializeTeam );
	}
} )( jQuery );
